import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import {
  BehaviorInputData,
  FidelityReviewSection,
  FormEventEmit,
} from '../../../fidelity.interface';
import { CorrectionNeededFormComponent } from '../correction-needed-form/correction-needed-form.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-correction-needed-assessment',
  standalone: true,
  imports: [CorrectionNeededFormComponent, CommonModule],
  templateUrl: './correction-needed-assessment.component.html',
})
export class CorrectionNeededAssessmentComponent implements OnChanges {
  @Input() fidelityData: BehaviorInputData | null = null;
  @Output() formValueChange = new EventEmitter<FormEventEmit>();

  assessmentData: FidelityReviewSection | null = null;
  ngOnChanges(): void {
    if (this.fidelityData) {
      this.assessmentData = this.fidelityData.fidelityData?.assesment ?? null;
    }
  }
}
